import { Component, OnInit, Inject, LOCALE_ID } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgForm } from "@angular/forms";
import { DeviceDetectorService } from "ngx-device-detector";

import { DealerService } from "../../dealer/services/dealer.service";
import { Dealer } from "../../shared/models/dealer.interface";
import { MonthType } from "../../shared/models/month.type.interface";
import { DealerEngagement, DealerEngagementResult } from "../models/dealer.engagement.interface";
import { ReportService } from "../services/report.service";
import { FileService } from "../../shared/services/file.service";
import { AbstractReportComponent } from "../abstract.report.component";

export interface DealerEngagementParameterData {
  dealerEngagement: DealerEngagement;
  dealers: Dealer[];
  years: number[];
  months: MonthType[];
  activeDealersOnly: boolean;
}

@Component({
  selector: 'app-dealer-engagement',
  templateUrl: './dealer.engagement.component.html',
  styleUrls: ['./dealer.engagement.component.scss']
})
export class DealerEngagementComponent extends AbstractReportComponent implements OnInit {

  report: DealerEngagementResult = null;
  parameters: DealerEngagement = {
    dealer_ID: null,
    year: null /*(new Date()).getFullYear()*/,
    startMonth: 0,
    endMonth: 11,
    startYear: null,
    endYear: null,
    activeDealersOnly: true
  } as DealerEngagement;

  dealer: Dealer;

  dealers: Dealer[];

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private dealerService: DealerService, private fileService: FileService, private reportService: ReportService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.dealerService.getList()
      .subscribe({
        next: (data) => {
          this.dealers = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.setupDates();
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;

        this.dealerService.getDealerEngagementExport(this.parameters, formatData.format)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'DealerEngagement' + formatData.extension);
            },
            error: (error: string) => this.onError(error)
          });
    });
  }

  showParameters() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    const dialogRef = this.dialog.open(DealerEngagementParameterDialog, {
      width: '550px',
      data: {
        dealerEngagement: (<any>Object).assign({}, this.parameters),

        activeDealersOnly: this.parameters.activeDealersOnly,
        dealers: this.dealers,
        years: this.years,
        months: this.months

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.dealerEngagement as DealerEngagement;
        this.reportService.setupParameters(this.parameters);

        this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);
        this.dealerService.getDealerEngagementReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'dealer.engagement.parameter.dialog',
  templateUrl: 'dealer.engagement.parameter.dialog.html',
})
export class DealerEngagementParameterDialog {
  allDealers: Dealer[] = [];
  constructor(
    public dialogRef: MatDialogRef<DealerEngagementParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DealerEngagementParameterData) {
    this.allDealers = data.dealers;
  }

  onCheckboxChange(event: any) {

    this.data.dealerEngagement.activeDealersOnly = this.data.activeDealersOnly;

    if (this.data.activeDealersOnly) {
      this.data.dealers = this.allDealers.filter(d => d.dealer_IsActive);
    }
    else {
      this.data.dealers = this.allDealers;
    }
  }

  runReport(form: NgForm): void {
    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
